export default {"src":"/_next/static/media/arrows-mobil-icon.0ef4bf87.svg","height":69,"width":48};